import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiGet } from "../../shared/apiClient";
import { ATTRIBUTE_VALUES_API, normalizeAttributeValue } from "../../shared/catalogMastersApi";

/** `/attribute-values?edit={id}` opens the attribute editor on the Attribute values tab. */
export function AttributeValuesPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const editParam = searchParams.get("edit");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!editParam) {
        navigate("/attribute-values-list", { replace: true });
        return;
      }
      const id = Number(editParam);
      if (!Number.isFinite(id)) {
        navigate("/attribute-values-list", { replace: true });
        return;
      }
      const res = await apiGet(`${ATTRIBUTE_VALUES_API}/${id}`);
      if (cancelled) return;
      if (!res.ok) {
        navigate("/attribute-values-list", { replace: true });
        return;
      }
      const row = normalizeAttributeValue(res.data);
      if (!row?.attributeId) {
        navigate("/attribute-values-list", { replace: true });
        return;
      }
      navigate(`/attributes?edit=${row.attributeId}&tab=values&valueEdit=${id}`, { replace: true });
    })();
    return () => {
      cancelled = true;
    };
  }, [editParam, navigate]);

  return (
    <div className="card">
      <div className="card-body">
        <p>Redirecting…</p>
      </div>
    </div>
  );
}
